var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Returns a Date object that has the same date as the passed in Date, but with its time normalized
 * to 12:00 AM.
 * @param date The Date (or Date argument) to copy and normalize.
 * @returns A copy of the passed in Date with its time set to 12:00 AM.
 */
export var normalizedDate = function () {
    var date = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        date[_i] = arguments[_i];
    }
    var copy = new (Date.bind.apply(Date, __spreadArray([void 0], __read(date), false)))();
    copy.setHours(0, 0, 0, 0);
    return copy;
};
var formatShortDateIntl = new Intl.DateTimeFormat([], { month: 'short', day: 'numeric' });
var formatShortDateAndTimeIntl = new Intl.DateTimeFormat([], { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' });
/**
 * Formats a date into a shortened time string.
 * @param date The Date to format the time for.
 * @param ampm Whether the include the "am"/"pm" suffix.
 * @returns The formatted time string.
 */
export var formatShortTime = function (date, ampm) {
    return "".concat((date.getHours() % 12) || 12).concat(date.getMinutes() === 0 ? '' : ':' + date.getMinutes().toString().padStart(2, '0')).concat(ampm ? date.getHours() < 12 ? 'am' : 'pm' : '');
};
/**
 * Formats a date into a shortened date string.
 * @param date The Date to format the date for.
 * @returns The formatted date string.
 */
export var formatShortDate = function (date) {
    return formatShortDateIntl.format(date);
};
/**
 * Formats a date into a shortened date and time string.
 * @param date The Date to format the date and time for.
 * @returns The formatted date and time string.
 */
export var formatShortDateAndTime = function (date) {
    return formatShortDateAndTimeIntl.format(date);
};
